import React from 'react';
import { useData } from '../../hooks';
import { WelcomeScreenMessage, WelcomeScreenNoMessage } from '../';
import styles from './WelcomeScreenMessageContainer.scss';

export const WelcomeScreenMessageContainer = () => {
  const { welcome_content } = useData();

  const noWelcomeMessage = (welcome_content: string | null) =>
    !welcome_content ||
    welcome_content.trim().length === 0 ||
    isNoTextContentInWelcomeHtml(welcome_content);

  const isNoTextContentInWelcomeHtml = (welcome_content: string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(welcome_content, 'text/html');
    const textContent = doc?.body?.firstChild?.textContent;
    return textContent === '';
  };

  return (
    <div className={styles.WelcomeScreenMessageContainerContainer}>
      {noWelcomeMessage(welcome_content) ? (
        <WelcomeScreenNoMessage />
      ) : (
        <WelcomeScreenMessage />
      )}
    </div>
  );
};
